import { timer } from 'rxjs';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { NavigationService } from 'src/app/services/navigation.service'; 

@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styleUrls: ['./areas.component.css']
})
export class AreasComponent {

  areas: any[] = [];
  searchTerm: string = '';
  originalAreas: any[] = [];
  loading: boolean = true;
  mensajeAreas: string = '';

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.verificacionUsuario();
  }

  verificacionUsuario(){
    this.navigationService.disableNavigation();
    const token = String(localStorage.getItem('token1'));
    timer(1).subscribe(() => {
      this.requestsService.getAllArea(token).subscribe(
        (data: any) => {
          this.areas = data;
          this.originalAreas = data;
          this.loading = false;
          this.areas.length === 0 && this.mensajeError(`No se tienen áreas de facturación que mostrar.`);
      });
    });
  }

  search() {
    if (this.searchTerm) {
      this.buscador();
    } else {
      this.areas = this.originalAreas;
    }
  }

  buscador(){
    this.areas = this.originalAreas.filter(area => {
      const nombre = area.Dir_Nombre ? area.Dir_Nombre.toLowerCase() : '';
      const clave = area.Dir_Clave ? area.Dir_Clave.toLowerCase() : '';
      const term = this.searchTerm.toLowerCase();
      
      return nombre.includes(term) || clave.includes(term);
    });
    this.areas.length === 0 && this.mensajeError(`Con los criterios ${this.searchTerm}, no encontramos ninguna coincidencia.`);
  }

  mensajeError(mensaje:string){
    this.mensajeAreas = mensaje;
  }

  editar(op: any, area: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.sharedService.setDataArray(area);
    this.router.navigate(['/areasD', opE]);
  }

  agregar(op: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.router.navigate(['/areasD', opE]);
  }

}
